export default {
  // Module name
  tasks: 'Tasks',
  task: 'Task',
  no_tasks_created: 'No task was created: the selected users do not have that role in the selected locations',
  // Task priority levels
  priority: {
    low: 'Low',
    medium: 'Medium',
    high: 'High'
  }
}
